import { IDotXetChungChiPhamViSinhVienActionTypes } from "../../action-types/xet-chung-chi/IDotXetChungChiPhamViSinhVienActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IDotXetChungChiPhamViSinhVienReducer } from "../../reducer-model/xet-chung-chi/IDotXetChungChiPhamViSinhVienReducer";

const iniState: IDotXetChungChiPhamViSinhVienReducer = {
    status: eReducerStatusBase.is_not_initialization,
    dotXetChungChiPhamViSinhViens: [],
    isHienThiTheoPhamViLop: false,
}

export const dotXetChungChiPhamViSinhVienReducer = (state: IDotXetChungChiPhamViSinhVienReducer = iniState, action: IDotXetChungChiPhamViSinhVienActionTypes): IDotXetChungChiPhamViSinhVienReducer => {
    switch (action.type) {
        case "DOT_XET_CHUNG_CHI_PHAM_VI_SINH_VIEN_LOAD_BY_DOT_XET_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "DOT_XET_CHUNG_CHI_PHAM_VI_SINH_VIEN_LOAD_BY_DOT_XET_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                dotXetChungChiPhamViSinhViens: action.payload,
            };
        case "DOT_XET_CHUNG_CHI_PHAM_VI_SINH_VIEN_LOAD_BY_DOT_XET_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "DOT_XET_CHUNG_CHI_PHAM_VI_SINH_VIEN_INSERTS_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "DOT_XET_CHUNG_CHI_PHAM_VI_SINH_VIEN_INSERTS_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "DOT_XET_CHUNG_CHI_PHAM_VI_SINH_VIEN_INSERTS_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "DOT_XET_CHUNG_CHI_PHAM_VI_SINH_VIEN_DELETES_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "DOT_XET_CHUNG_CHI_PHAM_VI_SINH_VIEN_DELETES_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "DOT_XET_CHUNG_CHI_PHAM_VI_SINH_VIEN_DELETES_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "DOT_XET_CHUNG_CHI_PHAM_VI_SINH_VIEN_CHANGE_IS_HIEN_THI_THEO_PHAM_VI_LOP":
            return {
                ...state,
                isHienThiTheoPhamViLop: action.payload,
            };
        default:
            return state;
    }
}